import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/setting/branch",
        component: List,
        name: "admin.setting.branch",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user/branch/create",
        component: Create,
        name: "admin.setting.branch.create",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/user/branch/:id?/edit",
        component: Edit,
        name: "admin.setting.branch.edit",
        meta: {
            requiresAuth: true,
        },
    },
];
